function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { PureComponent } from "react";
import { withRouter } from "next/router";
import { submitHubspotForm } from "client/services/hubspot-service/hubspot-service";
import { withGenericConfig } from "/contexts/generic-config-context";
import { SUBSCRIBE_BUTTON_BIGBRAIN_EVENT_NAME, SUBSCRIBE_BUTTON_RENDERED, CLICKED_SUBSCRIBE_BUTTON, SUBSCRIPTION_REQUESTED, SUBSCRIPTION_SUCCESS } from "/constants/bigbrain-event-types";
import EmailButtonComponent from "segments/desktop/core-components/button/email-button/email-button.js";
import { PORTAL_ID } from "client/services/hubspot-service/contact-form-config";
import DefaultProps from "./default-props";
import { StyledSubscribeButton } from "./subscribe-button.scss";
const FORM_GUID = "e13c9bb3-29ee-4ef1-b5b9-78d946c95502";
class SubscribeButton extends PureComponent {
    componentDidMount() {
        this.trackEvent(SUBSCRIBE_BUTTON_RENDERED);
    }
    trackEvent(eventName) {
        const { router } = this.props;
        BigBrain("track", SUBSCRIBE_BUTTON_BIGBRAIN_EVENT_NAME, {
            kind: eventName,
            placement: router.asPath
        });
    }
    render() {
        const { isButtonLoading, subscribed, emailValue } = this.state;
        const { translate } = this.props;
        const noticeText = subscribed && !emailValue ? translate("button.thankYou") : "";
        return /*#__PURE__*/ _jsx(StyledSubscribeButton, {
            className: "signup-button",
            children: /*#__PURE__*/ _jsx(EmailButtonComponent, _object_spread_props(_object_spread({}, this.props), {
                emailValue: emailValue,
                onButtonClick: this.onButtonClick,
                onEmailChange: this.onEmailChange,
                isLoading: isButtonLoading,
                borderColor: "gray",
                noticeText: noticeText
            }))
        });
    }
    constructor(props){
        super(props);
        var _this = this;
        _define_property(this, "onButtonClick", /*#__PURE__*/ _async_to_generator(function*() {
            const { subscribed, emailValue } = _this.state;
            _this.trackEvent(CLICKED_SUBSCRIBE_BUTTON);
            if (!subscribed) {
                _this.setState({
                    isButtonLoading: true
                });
                _this.trackEvent(SUBSCRIPTION_REQUESTED);
                const res = yield submitHubspotForm(PORTAL_ID, FORM_GUID, emailValue);
                if (res) {
                    _this.trackEvent(SUBSCRIPTION_SUCCESS);
                    _this.setState({
                        isButtonLoading: false,
                        subscribed: true,
                        emailValue: ""
                    });
                }
            }
        }));
        _define_property(this, "onEmailChange", (emailValue)=>{
            this.setState({
                emailValue,
                subscribed: false
            });
        });
        this.state = {
            isButtonLoading: false,
            subscribed: false,
            emailValue: ""
        };
    }
}
SubscribeButton.defaultProps = DefaultProps;
export default withGenericConfig(withRouter(SubscribeButton));
